import { Trans } from '@lingui/react/macro';

interface OptionToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  'aria-label': string;
}

function OptionToggle({ checked, onChange, 'aria-label': ariaLabel }: OptionToggleProps) {
  return (
    <div className="read-option-control">
      <button
        type="button"
        className="read-option-value text-xs"
        aria-pressed={checked}
        aria-label={ariaLabel}
        onClick={() => onChange(!checked)}
      >
        {checked ? <Trans>On</Trans> : <Trans>Off</Trans>}
      </button>
    </div>
  );
}

export default OptionToggle;
